// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bubble pre{ color:var(--main-gray-6);\n}\npre.ql-syntax{ display: block; background: var(--main-gray-1); border:1px solid var(--main-gray-2); padding: 5px;\n}\n.content p{ margin: 8px 0 8px 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
